import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Login form component
import { useState } from "react";
import { useLoginForm } from "../hooks/useAuthForm";
/**
 * Login form component for phone number input
 */
export function LoginForm({ onSuccess, onError, className }) {
    const [phoneNumber, setPhoneNumber] = useState("");
    const { handleSubmit, isLoading, error } = useLoginForm();
    const onSubmit = async (e) => {
        e.preventDefault();
        const result = await handleSubmit({ phoneNumber });
        if (result.success) {
            onSuccess?.(result.phoneNumber);
            // TODO: Show success message or redirect
        }
        else {
            onError?.(result.error);
        }
    };
    return (_jsx("div", { className: className, children: _jsxs("form", { onSubmit: onSubmit, className: "space-y-8", children: [_jsxs("div", { children: [_jsx("label", { htmlFor: "phoneNumber", className: "text-textPrimary block text-sm font-medium", children: "Phone Number" }), _jsx("input", { id: "phoneNumber", type: "tel", value: phoneNumber, onChange: (e) => setPhoneNumber(e.target.value), placeholder: "+1234567890", required: true, disabled: isLoading, className: "border-border bg-surface focus:border-accent focus:ring-accent mt-1 block w-full rounded-md border px-3 py-2 shadow-sm focus:outline-none disabled:cursor-not-allowed disabled:bg-gray-100" })] }), error && (_jsx("div", { className: "text-sm text-red-600", role: "alert", children: error })), _jsx("button", { type: "submit", disabled: isLoading || !phoneNumber.trim(), className: "bg-textPrimary focus:ring-accent flex w-full justify-center rounded-md border border-transparent px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:cursor-not-allowed disabled:bg-gray-400", children: isLoading ? "Sending..." : "Send OTP" })] }) }));
}
